export const getAllowedWorkspacesForSentryLogging = (): string[] => {
  const defaultAllowedWorkspaces: string[] = [];

  try {
    const allowedWorkspaces = import.meta.env.REACT_APP_ALLOWED_WORKSPACES_FOR_SENTRY_LOGGING;

    if (!allowedWorkspaces) {
      return defaultAllowedWorkspaces;
    }

    return allowedWorkspaces.split(",");
  } catch {
    return defaultAllowedWorkspaces;
  }
};
